import React, { useState } from 'react';
import { Clock, ThumbsUp, Users, ChevronLeft, ChevronRight } from 'lucide-react';

const demoImages = [
  { src: "/img/demo1.png", alt: "デモ画像1" },
  { src: "/img/demo2.png", alt: "デモ画像2" },
  { src: "/img/demo3.png", alt: "デモ画像3" },
  { src: "/img/demo4.png", alt: "デモ画像4" },
  { src: "/img/demo5.png", alt: "デモ画像5" },
  { src: "/img/demo6.png", alt: "デモ画像6" },
];

const benefits = [
  {
    icon: <Clock size={28} />,
    title: '業務効率化',
    description: '口コミ管理の時間を大幅に削減。AIがオーナーの返信パターンを学習し、より自然な返信文を生成します。'
  },
  {
    icon: <ThumbsUp size={28} />,
    title: '顧客満足度向上',
    description: '迅速な返信と丁寧な対応で、顧客満足度を向上。リピーターの増加につながります。'
  },
  {
    icon: <Users size={28} />,
    title: '見逃し防止',
    description: '新着口コミを自動検知してお知らせ。重要な顧客の声を見逃しません。'
  }
];

const UIShowcase: React.FC = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === demoImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? demoImages.length - 1 : prevIndex - 1
    );
  };

  return (
    <section id="benefit" className="section overflow-hidden">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="mb-4 text-3xl md:text-4xl font-semibold">導入のメリット</h2>
          <p className="max-w-2xl mx-auto text-lg">
            RepliGoの導入で、こんなメリットが得られます
          </p>
        </div>

        <div className="relative">
          {/* Benefits */}
          <div className="mt-16 grid md:grid-cols-3 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="text-center">
                <div className="text-blue-600 mb-4">{benefit.icon}</div>
                <div className="text-blue-600 font-medium text-lg mb-2">{benefit.title}</div>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default UIShowcase;